module.exports = __webpack_public_path__ + "static/MR_APR19_ALD_600x600px-1cef6c58b68f7546161812b43368c163.jpg";